import Client from 'Api/Client';
import EndPoint from 'Api/EndPoint';

const endpoint = `${EndPoint.Host}/${EndPoint.SearchWord}`;

export async function getRecentByUser() {
  return await Client.get(`${endpoint}/getRecentByUser`, { type: 'ORDER_SUPPORT' }, true);
}
